import { ApButtonDanger } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 24px;
  background-color: #f1f1f1;
  min-height: 100%;
  box-sizing: border-box;
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const PageTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PageTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 19px;
  line-height: 20px;
  color: #000000;
`;

export const PageSubtitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.87);
`;

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  flex: 1;
`;

export const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 24px;
  gap: 32px;
`;

export const IllustrationWrapper = styled.div`
  width: 124px;
  height: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Illustration = styled.img`
  width: 113px;
  height: 112px;
  object-fit: contain;
`;

export const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 800px;
  max-width: 100%;
`;

export const ProgressBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const ProgressHeading = styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 19px;
  line-height: 24px;
  color: #1a1a1a;
  text-align: center;
  margin: 0;
`;

export const ProgressBarRow = styled.div`
  width: 400px;
  max-width: 100%;
  height: 12px;
  background-color: #e7e7e7;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
`;

export const ProgressBarFill = styled.div<{ progress: number }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: ${({ progress }) => progress}%;
  background-color: #498e2b;
  border-radius: 4px;
`;

export const ProgressPercent = styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #1a1a1a;
  text-align: center;
  margin: 0;
`;

export const CancelButton = styled(ApButtonDanger)`
  && {
    height: 32px;
    background-color: #cb282e;
    border-color: #cb282e;
    color: #ffffff;
  }
  && span {
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.3px;
    color: #ffffff;
  }
`;

export const ProgressBody = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #1a1a1a;
  text-align: center;
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    margin: 0;
  }
`;
